<div id="case-participants" class="container-fluid pb-3">

    <ng-template #participantListItem let-item="data">
        <span class="action-list-display-name">
            {{item.actionListDisplayName}}
            <small *ngIf="isParticipantModified(item)">
                <mat-icon>warning</mat-icon>
            </small>
        </span>
    </ng-template>

    <div class="row">

        <!-- LEFT COLUMN WITH PARTICIPANT LIST -->

        <div class="col-sm-4">
            <mat-card>
                <mat-card-content>

                    <action-list *ngIf="participants"
                                 [idPrefix]="idPrefix"
                                 [items]="participants.items"
                                 [selected]="selectedParticipant"
                                 [identifier]="'id'"
                                 [options]="actionListOptions"
                                 [template]="participantListItem"
                                 (select)="openParticipant($event)"
                                 (delete)="deleteParticipant($event)">
                    </action-list>

                    <new-participant *ngIf="newParticipantPanelOpen"
                                     [idPrefix]="(idPrefix + 'new.')"
                                     [title]="'detailed_processing.participant.title.new_participant' | translate"
                                     [(panelOpen)]="newParticipantPanelOpen"
                                     [typeSelectOptions]="participantTypeSelectOptions"
                                     [participantTypeUriBuilderParams]="participantTypeUriBuilderParams"
                                     (create)="createParticipant($event)">
                    </new-participant>

                    <button id="{{idPrefix}}btn.open_new_participant_panel"
                            mat-flat-button
                            color="accent"
                            class="w-100 mt-3"
                            *ngIf="!newParticipantPanelOpen"
                            (click)="openNewParticipantPanel()"
                            [disabled]="allTypesCreated(ParticipantTypes.ALL.length)">
                        <mat-icon>add</mat-icon>{{ 'detailed_processing.participant.btn.create' | translate }}
                    </button>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH PARTICIPANT DETAILS -->

        <div class="col-sm-8" *ngIf="selectedParticipant">

            <mat-card>
                <mat-card-content>
                    <participant-details [idPrefix]="(idPrefix + 'selected.')"
                                         [bananaBox]="selectedParticipant"
                                         [participants]="participants"
                                         [case]="case"
                                         [disabled]="disabled"
                                         (caseUpdate)="patchAndUpdateWithValue($event)"
                                         (caseMultiUpdate)="patchOpDataArray($event)">
                    </participant-details>
                </mat-card-content>
            </mat-card>

        </div>
    </div>

</div>
